export default class PrintPage {
  static init () {
    if (document.querySelectorAll('.js-print').length === 0) { return }
    new PrintPage()
  }

  constructor () {
    this.seenPrintClasses = new Set()

    for (const btn of document.querySelectorAll('.js-print')) {
      btn.addEventListener('click', e => this.handlePrint(e), true)
    }
  }

  handlePrint (event) {
    const printId = event.currentTarget.dataset.printId
    const printClass = event.currentTarget.dataset.printClass
    const target = document.getElementById(printId)

    if (target) {
      event.preventDefault()
      event.stopPropagation()

      this.seenPrintClasses.add(printClass)
      this.dropPrintClasses()

      target.classList.add(printClass)
      window.print()
    }
  }

  dropPrintClasses () {
    for (const printClass of this.seenPrintClasses) {
      for (const elem of document.querySelectorAll(`.${printClass}`)) {
        elem.classList.remove(printClass)
      }
    }
  }
}
